<template>
  <div>
    <v-tooltip v-if="areFiltersActiveInStore" top>
      <template #activator="{ on }">
        <v-btn
          class="mr-2"
          icon
          outlined
          small
          depressed
          v-on="on"
          @click="onResetFilters"
        >
          <v-icon x-small>fal fa-times</v-icon>
        </v-btn>
      </template>
      <span>
        Reset all filters
      </span>
    </v-tooltip>
    <v-menu
      v-model="menuVisible"
      :close-on-content-click="false"
      offset-y
      transition="slide-y-transition"
      min-width="100vw"
      nudge-bottom="20"
    >
      <template #activator="{ on }">
        <v-btn
          :outlined="!areFiltersActive && !areFiltersActiveInStore"
          :color="
            !areFiltersActive && !areFiltersActiveInStore
              ? ''
              : $vuetify.theme.dark
              ? 'secondary'
              : 'primary'
          "
          rounded
          small
          depressed
          v-on="on"
        >
          <v-icon class="mr-2" x-small>fal fa-filter</v-icon>
          {{
            areFiltersActive || areFiltersActiveInStore
              ? activeButtonTitle
              : inactiveButtonTitle
          }}
        </v-btn>
      </template>
      <v-card tile>
        <v-card-text class="px-6">
          <div class="py-md-6 px-md-8">
            <!-- Close button -->
            <div class="close-wrapper pa-8">
              <v-btn
                :color="$vuetify.theme.dark ? 'secondary' : 'primary'"
                fab
                x-small
                dark
                depressed
                @click="onClose"
              >
                <v-icon small dark>fal fa-times</v-icon>
              </v-btn>
            </div>
            <!-- End close button -->
            <!-- Prime or Inspiration to Elite filter -->
            <div
              v-if="
                (from === 'prime' || from === 'inspiration') &&
                  me &&
                  (me.isAdmin || me.role === types.user.role.curator)
              "
              class="mb-6"
            >
              <h5 class="ml-1 text-subtitle-2 font-weight-bold">
                <span v-if="from === 'prime'">Vote for Elite or Inspiration gallery</span>
                <span v-else>Vote for Elite gallery</span>
              </h5>
              <p class="ml-1 mb-2 text-caption">
                Here is where you can help 100ASA to find the best photos by
                voting for the Elite{{ from === 'prime' ? ' or the Inspiration' : ''}} gallery. If a photo reaches the minium
                required number of votes, it will be published to the gallery.
              </p>
              <v-btn
                v-model="selectedFilters._showVotedForElite"
                :outlined="!selectedFilters._showVotedForElite"
                active-class="bluezone"
                color="bluezone secondary--text"
                depressed
                rounded
                small
                class="ma-1"
                @click="onToggleVotedForElite()"
              >
                Show Elite votes
              </v-btn>
              <v-btn
                v-if="from === 'prime'"
                v-model="selectedFilters._showVotedForInspiration"
                :outlined="!selectedFilters._showVotedForInspiration"
                active-class="bluezone"
                color="bluezone secondary--text"
                depressed
                rounded
                small
                class="ma-1"
                @click="onToggleVotedForInspiration()"
              >
                Show Inspiration votes
              </v-btn>
            </div>
            <!-- End Prime or Inspiration to Elite filter -->
            <!-- Full text search -->
            <div class="mb-6">
              <div class="ml-1 mw-320">
                <v-text-field
                  v-model="selectedFilters._searchTerm"
                  prepend-inner-icon="fal fa-search fa-sm"
                  label="Search by keyword or #tags"
                />
              </div>
            </div>
            <!-- End Full text search -->
            <!-- Sorting -->
            <div v-if="from !== 'prints'" class="mb-6">
              <h5 class="ml-1 mb-3 text-subtitle-2 font-weight-bold">
                Sorting
              </h5>
              <div>
                <v-btn
                  v-for="(s, i) in sortingValues"
                  :key="i"
                  :input-value="s.value === selectedFilters._sorting"
                  :outlined="s.value !== selectedFilters._sorting"
                  :active-class="$vuetify.theme.dark ? 'secondary' : 'primary'"
                  depressed
                  rounded
                  small
                  class="ma-1"
                  @click="onChangeSorting(s.value)"
                >
                  {{ s.text }}
                </v-btn>
              </div>
            </div>
            <!-- End sorting -->
            <!-- Categories -->
            <div>
              <h5 class="ml-1 mb-3 text-subtitle-2 font-weight-bold">
                Categories
              </h5>
              <div>
                <v-btn
                  v-for="(c, i) in categories"
                  :key="i"
                  :input-value="c.value === selectedFilters._selectedCategory"
                  :outlined="c.value !== selectedFilters._selectedCategory"
                  :active-class="$vuetify.theme.dark ? 'secondary' : 'primary'"
                  depressed
                  rounded
                  small
                  class="ma-1"
                  @click="onChangeCategory(c)"
                >
                  {{ c.text }}
                </v-btn>
              </div>
            </div>
            <!-- End categories -->
            <!-- Tags -->
            <div
              v-if="
                selectedFilters._selectedTags &&
                  selectedFilters._selectedTags !== '0'
              "
              class="mt-6"
            >
              <h5 class="ml-1 mb-3 text-subtitle-2 font-weight-bold">
                Tags
              </h5>
              <p class="ma-0 ml-1">
                Filtered by tag
                <strong>
                  {{ selectedTags || selectedFilters._selectedTags }}
                </strong>
                <span class="ml-1">
                  <v-btn
                    depressed
                    rounded
                    small
                    dark
                    class="ma-1"
                    @click="onResetTags()"
                  >
                    clear
                  </v-btn>
                </span>
              </p>
            </div>
            <!-- End tags -->
            <v-divider class="mx-1 my-8" />
            <div class="px-1">
              <v-btn
                v-if="areFiltersActive || areFiltersActiveInStore"
                outlined
                depressed
                class="mr-3"
                @click="onClear"
              >
                Clear
              </v-btn>
              <v-btn
                :class="$vuetify.theme.dark ? 'secondary' : 'primary'"
                depressed
                @click="_onApply"
              >
                Apply
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import types from '@/utils/types'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'GalleryFilters',
  props: {
    from: {
      type: String,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    onApply: {
      type: Function,
      required: true
    },
    inactiveButtonTitle: {
      type: String,
      default: 'Show filters'
    },
    activeButtonTitle: {
      type: String,
      default: 'Filters active'
    }
  },
  data() {
    return {
      types,
      menuVisible: false,
      selectedFilters: {
        _searchTerm: '',
        _sorting: '',
        _selectedCategory: '0',
        _selectedCategoryText: '',
        _selectedTags: '0',
        _showVotedForElite: false,
        _showVotedForInspiration: false
      }
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.user,
      searchTerm: state => state.photos.searchTerm,
      sorting: state => state.photos.sorting,
      selectedTags: state => state.photos.selectedTags,
      selectedCategory: state => state.photos.selectedCategory,
      selectedCategoryText: state => state.photos.selectedCategoryText,
      showVotedForElite: state => state.photos.isEliteVotedActive,
      showVotedForInspiration: state => state.photos.isInspirationVotedActive
    }),
    areFiltersActive() {
      return (
        this.selectedFilters._searchTerm ||
        this.selectedFilters._sorting !== 'desc' ||
        (this.selectedFilters._selectedCategory &&
          this.selectedFilters._selectedCategory !== '0') ||
        (this.selectedFilters._selectedTags &&
          this.selectedFilters._selectedTags !== '0') ||
        ((this.from === 'prime' || this.from === 'inspiration') &&
          this.selectedFilters._showVotedForElite) ||
          (this.from === 'prime' && this.selectedFilters._showVotedForInspiration)
      )
    },
    areFiltersActiveInStore() {
      return (
        this.searchTerm ||
        this.sorting !== 'desc' ||
        (this.selectedCategory && this.selectedCategory !== '0') ||
        (this.selectedTags && this.selectedTags !== '0') ||
        ((this.from === 'prime' || this.from === 'inspiration') &&
          this.showVotedForElite) ||
          (this.from === 'prime' && this.showVotedForInspiration)
      )
    },
    sortingValues() {
      const options = [
        {
          value: 'desc',
          text: 'Newer'
        },
        {
          value: 'asc',
          text: 'Older'
        }
      ]
      return options
    }
  },
  watch: {
    selectedCategory(newCategory) {
      this.selectedFilters._selectedCategory = newCategory
    },
    selectedTags(newTags) {
      this.selectedFilters._selectedTags = newTags
    }
  },
  mounted() {
    this.selectedFilters._searchTerm = this.searchTerm
    this.selectedFilters._sorting = this.sorting
    this.selectedFilters._selectedCategory = this.selectedCategory
    this.selectedFilters._selectedTags = this.selectedTags
    this.selectedFilters._showVotedForElite = this.showVotedForElite
    this.selectedFilters._showVotedForInspiration = this.showVotedForInspiration

    EventBus.$on('set-category', category => {
      this.onChangeCategory(category)
      this._onApply()
    })

    EventBus.$on('set-vote-for-elite', () => {
      this.onToggleVotedForElite(true)
      this._onApply()
    })

    EventBus.$on('set-vote-for-inspiration', () => {
      this.onToggleVotedForInspiration(true)
      this._onApply()
    })

    EventBus.$on('set-vote-for-prime', () => {
      this.onTogglePromotables(true)
      this._onApply()
    })
  },
  beforeDestroy() {
    EventBus.$off('set-category')
    EventBus.$off('set-vote-for-elite')
    EventBus.$off('set-vote-for-inspiration')
    EventBus.$off('set-vote-for-prime')
  },
  methods: {
    onTogglePromotables(forceTrue) {
      if (this.me && this.me.id) {
        if (this.me.role === types.user.role.user) {
          EventBus.$emit('snackbar', {
            text:
              'Only users ranked Scholar or higher can vote to promote photos',
            color: 'info'
          })
        } else {
          this.selectedFilters._sorting = 'desc'
        }
      } else {
        EventBus.$emit('snackbar', {
          text: 'You need to log in to use this filter',
          color: 'info'
        })
      }
    },
    onToggleVotedForElite(forceTrue) {
      if (this.me && this.me.id) {
        if (this.me.role === types.user.role.curator || this.me.isAdmin) {
          this.selectedFilters._showVotedForInspiration = false
          this.selectedFilters._showVotedForElite =
            forceTrue || !this.selectedFilters._showVotedForElite
        } else {
          EventBus.$emit('snackbar', {
            text: 'You cannot access this filter',
            color: 'info'
          })
        }
      } else {
        EventBus.$emit('snackbar', {
          text: 'You need to log in to use this filter',
          color: 'info'
        })
      }
    },
    onToggleVotedForInspiration(forceTrue) {
      if (this.me && this.me.id) {
        if (this.me.role === types.user.role.curator || this.me.isAdmin) {
          this.selectedFilters._showVotedForElite = false
          this.selectedFilters._showVotedForInspiration =
            forceTrue || !this.selectedFilters._showVotedForInspiration
        } else {
          EventBus.$emit('snackbar', {
            text: 'You cannot access this filter',
            color: 'info'
          })
        }
      } else {
        EventBus.$emit('snackbar', {
          text: 'You need to log in to use this filter',
          color: 'info'
        })
      }
    },
    onChangeSorting(value) {
      this.selectedFilters._sorting = value
    },
    onChangeCategory(c) {
      this.$store.dispatch('photos/setCategory', c && c.text ? c.text : '')
      this.selectedFilters._selectedCategory = c.value
      this.selectedFilters._selectedCategoryText = c.text.toLowerCase()
      if (c && c.text) {
        this.$router.push({
          query: { category: c.text.toLowerCase() }
        })
      } else {
        this.$router.push({
          query: {}
        })
      }
    },
    onResetTags() {
      this.$store.dispatch('photos/setTags', '')
      this.selectedFilters._selectedTags = '0'
      this.$router.push({
        query: {}
      })
    },
    onClose() {
      this.menuVisible = false
    },
    onClear() {
      this.selectedFilters._searchTerm = ''
      this.selectedFilters._sorting = 'desc'
      this.selectedFilters._selectedCategory = '0'
      this.selectedFilters._selectedCategoryText = ''
      this.selectedFilters._selectedTags = '0'
      this.selectedFilters._showVotedForElite = false
      this.selectedFilters._showVotedForInspiration = false
      this.$store.dispatch('photos/setFilters', this.selectedFilters)
      this.$store.dispatch('photos/setReload', true)
      EventBus.$emit('hide-upcoming-banner')
      this.$router.push({
        query: {}
      })
    },
    onResetFilters() {
      this.onClear()
      this._onApply()
    },
    _onApply() {
      this.$store.dispatch('photos/setReload', true)
      this.onApply(this.selectedFilters)
      EventBus.$emit('hide-upcoming-banner')
      this.menuVisible = false
    }
  }
}
</script>

<style scoped>
.close-wrapper {
  position: absolute;
  top: 0;
  right: 0;
}
.mw-320 {
  max-width: 320px;
}
</style>
